export enum ACTION {
  UPDATE_FILTERS = 'UPDATE_FILTERS',
  UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS = 'UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS',
  UPDATE_DATA = 'UPDATE_DATA',
  ADD_UPDATED_TIMESTAMP = 'ADD_UPDATED_TIMESTAMP',
  UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS = 'UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS',
  UPDATE_CAN_ACCESS_TOF_PREMIUM = 'UPDATE_CAN_ACCESS_TOF_PREMIUM',
}

export enum COLORS {
  BRAND = '#006AFF',
  YELLOW400 = '#F2A619',
  YELLOW600 = '#8A5700',
  BLUE500 = '#0D4599',
  LIGHTBLUE = '#E0F2FF',
  GRAY200 = '#F1F1F4',
  GRAY300 = '#D1D1D5',
  GRAY400 = '#A6B3C4',
  TEXT_MEDIUM = '#596B82',
}

export interface IFilters {
  filterType: string;
  beds: string | undefined;
  propertyType: string | undefined;
}

export interface AddUpdatedTimestampAction {
  type: ACTION.ADD_UPDATED_TIMESTAMP;
  payload: { updatedTimestamp: number };
}

export interface UpdatePremiumFiltersAction {
  type: ACTION.UPDATE_FILTERS;
  payload: { filters: Partial<IFilters> };
}

export interface UpdatePremiumOverviewLoadingStatusAction {
  type: ACTION.UPDATE_PREMIUM_OVERVIEW_LOADING_STATUS;
  payload: { isPremiumOverviewLoading: boolean };
}

export interface UpdateDataAction {
  type: ACTION.UPDATE_DATA;
  payload: { data: Partial<IFreemiumState> };
}

export interface UpdatePremiumAnalyticsFilterModalStatusAction {
  type: ACTION.UPDATE_PREMIUM_ANALYTICS_FILTER_MODAL_STATUS;
  payload: { isPremiumAnalyticsFilterModalOpen: boolean };
}

export interface UpdateCanAccessTofPremiumAction {
  type: ACTION.UPDATE_CAN_ACCESS_TOF_PREMIUM;
  payload: { canAccessTopOfFunnelPremium: boolean };
}

export type FreemiumAction =
  | AddUpdatedTimestampAction
  | UpdatePremiumFiltersAction
  | UpdatePremiumOverviewLoadingStatusAction
  | UpdateDataAction
  | UpdatePremiumAnalyticsFilterModalStatusAction
  | UpdateCanAccessTofPremiumAction;

export interface InquiryPayload {
  count?: number;
  isProperty?: boolean;
  isMarketMedian?: boolean;
  price?: string;
  labelListDataKey?: string;
}

export type MarketListingsPayload = {
  timestamp: string;
  compsCount: number;
  cityCount: number;
};

export type FilterCriteria = {
  filterType: string;
  propertyType: number | null | string;
  beds: number | null | string;
};

export type FreemiumProduct = {
  price: string;
  type: number;
  duration: string;
  description: { benefits: Array<unknown>; title: string; subtitle: string };
};

export type IFreemiumState = {
  featuresOfPremiumRef?: React.RefObject<HTMLDivElement> | null;
  isPremiumOverviewLoading: boolean;
  isPremiumAnalyticsFilterModalOpen: boolean;
  isListingActive: boolean;
  updatedTimestamps: Array<number>;
  filters: IFilters;
  canAccessTopOfFunnelPremium: boolean;
};
